// Use these instead of `new Date().toISOString().slice(0, 10)` - `toISOString()` is UTC, which is
// off-by-one for users east/west of UTC whenever the local date differs from the UTC date.
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/items/src/periodicReviewDates.ts

const pad2 = (n: number): string => String(n).padStart(2, '0');

// Returns the local-calendar YYYY-MM-DD for the given date (default: now).
export const localDateToYMD = (d: Date = new Date()): string =>
  `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

// Dates returned by the API may include the UTC-midnight suffix.
export const dateToYMD = (value?: string | null): string => value?.slice(0, 10) ?? '';
export const ymdToLocalDate = (value?: string | null): Date | null =>
  value ? new Date(`${dateToYMD(value)}T00:00:00`) : null;
export const parseCalendarDate = (value?: string | null): Date | null => {
  const ymd = value?.trim();
  if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  const date = ymdToLocalDate(ymd);
  return date && !Number.isNaN(date.getTime()) && localDateToYMD(date) === ymd ? date : null;
};
export const formatCalendarDate = (date?: Date | null): string => (date ? localDateToYMD(date) : '');
export const formatDateOnly = (value?: string | null, short = false): string => {
  const date = ymdToLocalDate(value);
  if (!date) return '';
  return date.toLocaleDateString(short ? 'en-CA' : 'en-GB', {
    year: 'numeric',
    month: short ? '2-digit' : 'long',
    day: '2-digit',
  });
};
